module.exports = __webpack_public_path__ + "img/avatar.5db32383.png";